{
  "familyId": "REK-CONTEXT-MEERSTAPS",
  "questions": [
    {
      "id": "REK-CONTEXT-MEERSTAPS-001",
      "familyId": "REK-CONTEXT-MEERSTAPS",
      "module": "Basisrekenen",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_meerstaps",
      "questionType": "step_solver",
      "question": "Een cateraar bereidt lunch voor 85 personen. Elk broodje kost €1,80 en elke persoon krijgt 2 broodjes. Daarnaast bestelt ze 10 flessen sap van €3,50 per fles. Wat zijn de totale kosten?",
      "context": null,
      "options": [],
      "correctAnswer": "341",
      "data": {
        "stepSolver": {
          "context": "85 personen, 2 broodjes p.p. à €1,80, 10 flessen sap à €3,50",
          "steps": [
            {
              "prompt": "Hoeveel broodjes zijn er in totaal nodig? (85 personen × 2 broodjes)",
              "correctAnswer": "170",
              "acceptedAnswers": ["170"],
              "hint": "Elke persoon krijgt 2 broodjes: 85 × 2"
            },
            {
              "prompt": "Wat kosten alle broodjes samen? (170 × €1,80)",
              "correctAnswer": "306",
              "acceptedAnswers": ["306", "€306", "€ 306"],
              "hint": "170 broodjes × €1,80 per stuk"
            },
            {
              "prompt": "Wat kosten de 10 flessen sap? (10 × €3,50)",
              "correctAnswer": "35",
              "acceptedAnswers": ["35", "€35", "€ 35"],
              "hint": "10 flessen × €3,50 per fles"
            },
            {
              "prompt": "Wat zijn de totale kosten? (broodjes + sap)",
              "correctAnswer": "341",
              "acceptedAnswers": ["341", "€341", "€ 341"],
              "hint": "€306 + €35"
            }
          ],
          "showStepsProgressively": true
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Meerstaps: splits in deelproblemen",
            "content": "Stap 1: Hoeveel broodjes? 85 × 2 = 170. Stap 2: Kosten broodjes? 170 × €1,80 = €306. Stap 3: Kosten sap? 10 × €3,50 = €35. Stap 4: Totaal? €306 + €35 = €341. Tip: maak een plan vóór je gaat rekenen!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_meerstaps_kosten",
      "variantIndex": 1,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.82,
      "feedback": {
        "explanationText": "Stap 1: Aantal broodjes = 85 × 2 = 170. Stap 2: Kosten broodjes = 170 × €1,80 = €306. Stap 3: Kosten sap = 10 × €3,50 = €35. Stap 4: Totaal = €306 + €35 = €341. Bij meerstaps-opgaven: maak eerst een plan, reken dan stap voor stap. Tegenproef: €306 + €35 = €341 ✓",
        "solutionSteps": [
          "Stap 1: Aantal broodjes = 85 × 2 = 170",
          "Stap 2: Kosten broodjes = 170 × €1,80 = €306",
          "Stap 3: Kosten sap = 10 × €3,50 = €35",
          "Stap 4: Totaal = €306 + €35 = €341 ✓"
        ]
      },
      "pedagogy": {
        "dok": 3
      }
    },
    {
      "id": "REK-CONTEXT-MEERSTAPS-002",
      "familyId": "REK-CONTEXT-MEERSTAPS",
      "module": "Basisrekenen",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_meerstaps",
      "questionType": "multiple_choice",
      "question": "Een school organiseert een uitje voor 124 leerlingen. Er gaan bussen met 45 zitplaatsen. Elke bus kost €275. Hoeveel kost het busvervoer in totaal?",
      "context": null,
      "options": ["€550", "€915", "€825", "€1.100"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "strategySteps",
          "showWhen": "wrong",
          "data": {
            "title": "Meerstaps: bussen + kosten",
            "steps": [
              { "label": "124 ÷ 45 = 2,75" },
              { "label": "naar boven → 3 bussen", "highlight": true },
              { "label": "3 × €275 = €825" }
            ],
            "label": "Bij 'minimaal nodig' altijd naar boven afronden"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Eerst: hoeveel bussen? Dan: kosten",
            "content": "Stap 1: Hoeveel bussen? 124 ÷ 45 = 2,75... → je hebt 3 bussen nodig (naar boven afronden!). Stap 2: Kosten = 3 × €275 = €825. Let op: bij 'hoeveel nodig' rond je ALTIJD naar boven af!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_meerstaps_afronden_boven",
      "variantIndex": 2,
      "citoDifficulty": 0.56,
      "citoDiscrimination": 0.84,
      "feedback": {
        "explanationText": "Stap 1: 124 ÷ 45 = 2,75... → je hebt 3 bussen nodig (naar boven afronden!). Stap 2: 3 × €275 = €825. Let op: bij 'hoeveel nodig' rond je altijd naar boven af — je kunt geen 0,75 bus bestellen. Tegenproef: 3 × 275 = 825 ✓",
        "solutionSteps": [
          "Stap 1: 124 ÷ 45 = 2,75...",
          "Stap 2: Naar boven afronden → 3 bussen",
          "Stap 3: 3 × €275 = €825 ✓"
        ],
        "distractorExplanations": {
          "0": "Je rondde af naar 2 bussen. Maar 2 × 45 = 90 zitplaatsen — niet genoeg voor 124 leerlingen! Je hebt 3 bussen nodig: 3 × €275 = €825. Tegenproef: 3 × 275 = 825 ✓.",
          "1": "Je rekende 3 × €305 (een afgerond bedrag) = €915. Maar elke bus kost precies €275 — werk met het exacte bedrag: 3 × €275 = €825.",
          "2": "Goed! 3 bussen × €275 = €825. Je rondde correct naar boven af. Tegenproef: 3 × 45 = 135 zitplaatsen ≥ 124 ✓.",
          "3": "Je dacht 4 bussen × €275 = €1.100. Maar 3 bussen × 45 = 135 zitplaatsen — dat is genoeg voor 124 leerlingen."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "rek.rounding-wrong-direction", "label": "Naar beneden afgerond i.p.v. naar boven", "optionIndex": 0 },
          { "id": "rek.context-wrong-scale", "label": "Afgerond bedrag per bus gebruikt i.p.v. exact", "optionIndex": 1 },
          { "id": "rek.calculation-error", "label": "Te veel bussen berekend", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-CONTEXT-MEERSTAPS-003",
      "familyId": "REK-CONTEXT-MEERSTAPS",
      "module": "Basisrekenen",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_meerstaps",
      "questionType": "multiple_choice",
      "question": "Een schilder schildert 3 kamers. Kamer 1 is 4 × 5 meter, kamer 2 is 3 × 6 meter en kamer 3 is 4 × 4 meter. Een blik verf dekt 10 m². Hoeveel blikken verf heeft ze minimaal nodig?",
      "context": null,
      "options": ["5 blikken", "6 blikken", "7 blikken", "4 blikken"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "strategySteps",
          "showWhen": "wrong",
          "data": {
            "title": "Oppervlakte → blikken",
            "steps": [
              { "label": "20 + 18 + 16 = 54 m²" },
              { "label": "54 ÷ 10 = 5,4", "highlight": true },
              { "label": "naar boven → 6 blikken" }
            ],
            "label": "Eerst totaal oppervlakte, dan delen, dan afronden"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Oppervlakte berekenen, dan delen",
            "content": "Stap 1: Oppervlaktes: 4×5=20, 3×6=18, 4×4=16 m². Stap 2: Totaal = 20+18+16 = 54 m². Stap 3: 54 ÷ 10 = 5,4 → naar boven afronden = 6 blikken. Je kunt geen 0,4 blik kopen!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_meerstaps_oppervlakte",
      "variantIndex": 3,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "Stap 1: Oppervlaktes: 4 × 5 = 20, 3 × 6 = 18, 4 × 4 = 16 m². Stap 2: Totaal = 20 + 18 + 16 = 54 m². Stap 3: 54 ÷ 10 = 5,4 → naar boven afronden = 6 blikken. Bij 'minimaal nodig' rond je altijd naar boven af. Tegenproef: 6 × 10 = 60 m² ≥ 54 m² ✓",
        "solutionSteps": [
          "Kamer 1: 4 × 5 = 20 m²",
          "Kamer 2: 3 × 6 = 18 m²",
          "Kamer 3: 4 × 4 = 16 m²",
          "Totaal: 20 + 18 + 16 = 54 m²",
          "54 ÷ 10 = 5,4 → 6 blikken nodig ✓"
        ],
        "distractorExplanations": {
          "0": "Je rondde 5,4 af naar beneden (5). Maar met 5 blikken dek je maar 50 m² — niet genoeg voor 54 m². Je hebt 6 blikken nodig.",
          "1": "Goed! 54 m² ÷ 10 = 5,4 → 6 blikken nodig.",
          "2": "7 blikken is te veel. 54 ÷ 10 = 5,4, dus 6 blikken is genoeg (6 × 10 = 60 m² > 54 m²).",
          "3": "Je vergat waarschijnlijk een kamer. Alle drie kamers: 20 + 18 + 16 = 54 m², niet 40 m². 54 ÷ 10 = 5,4 → 6 blikken."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "rek.rounding-wrong-direction", "label": "Naar beneden afgerond i.p.v. naar boven", "optionIndex": 0 },
          { "id": "rek.calculation-error", "label": "Te veel blikken berekend", "optionIndex": 2 },
          { "id": "rek.context-step-forgotten", "label": "Een kamer vergeten mee te tellen", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-CONTEXT-MEERSTAPS-004",
      "familyId": "REK-CONTEXT-MEERSTAPS",
      "module": "Basisrekenen",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_meerstaps",
      "questionType": "fill_in",
      "question": "Een winkelier koopt 50 T-shirts in voor €8 per stuk. Ze verkoopt er 35 voor €15 per stuk. De rest verkoopt ze in de uitverkoop voor €6 per stuk. Hoeveel winst maakt ze in totaal?",
      "context": null,
      "options": [],
      "correctAnswer": "215",
      "data": {
        "acceptedAnswers": ["215", "€215", "215 euro"]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Winst = opbrengst − kosten",
            "content": "Stap 1: Inkoopkosten = 50 × €8 = €400. Stap 2: Opbrengst normaal = 35 × €15 = €525. Stap 3: Opbrengst uitverkoop = 15 × €6 = €90. Stap 4: Totale opbrengst = €525 + €90 = €615. Stap 5: Winst = €615 − €400 = €215.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_meerstaps_winst",
      "variantIndex": 4,
      "citoDifficulty": 0.62,
      "citoDiscrimination": 0.82,
      "feedback": {
        "explanationText": "Stap 1: Inkoop = 50 × €8 = €400. Stap 2: Opbrengst normaal = 35 × €15 = €525. Stap 3: Uitverkoop = 15 × €6 = €90. Stap 4: Totale opbrengst = €525 + €90 = €615. Stap 5: Winst = €615 − €400 = €215. Tegenproef: €615 − €400 = €215 ✓",
        "solutionSteps": [
          "Inkoop: 50 × €8 = €400",
          "Opbrengst normaal: 35 × €15 = €525",
          "Uitverkoop: (50 − 35) = 15 shirts × €6 = €90",
          "Totale opbrengst: €525 + €90 = €615",
          "Winst: €615 − €400 = €215 ✓"
        ]
      },
      "pedagogy": {
        "dok": 4,
        "misconceptionTags": [
          { "id": "rek.context-step-forgotten", "label": "Uitverkoop-opbrengst vergeten" },
          { "id": "rek.context-wrong-data", "label": "Aangenomen dat alle shirts voor dezelfde prijs verkocht" },
          { "id": "rek.context-step-forgotten", "label": "Verlies op uitverkoop niet meegeteld" }
        ]
      }
    },
    {
      "id": "REK-CONTEXT-MEERSTAPS-005",
      "familyId": "REK-CONTEXT-MEERSTAPS",
      "module": "Basisrekenen",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_meerstaps",
      "questionType": "multiple_choice",
      "question": "Een magazijnmedewerker moet 864 pakketjes verdelen over 3 vrachtwagens. Elke vrachtwagen heeft 12 pallets en op elke pallet passen 24 pakketjes. Passen alle pakketjes in de vrachtwagens?",
      "context": null,
      "options": [
        "Nee, er passen maar 720 pakketjes",
        "Nee, er passen maar 840 pakketjes",
        "Ja, er passen precies 864 pakketjes",
        "Ja, er is zelfs ruimte over voor 36 extra pakketjes"
      ],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Capaciteit berekenen: stap voor stap",
            "content": "Stap 1: Pakketjes per vrachtwagen = 12 pallets × 24 pakketjes = 288. Stap 2: Totale capaciteit = 3 × 288 = 864. Stap 3: Vergelijk: 864 pakketjes = 864 capaciteit → past precies!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_meerstaps_capaciteit",
      "variantIndex": 5,
      "citoDifficulty": 0.54,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Stap 1: Per vrachtwagen: 12 × 24 = 288 pakketjes. Stap 2: Totaal: 3 × 288 = 864. Stap 3: 864 = 864 → past precies! Bij dit soort opgaven bereken je eerst de totale capaciteit en vergelijk je die met het aantal. Tegenproef: 3 × 12 × 24 = 864 ✓",
        "solutionSteps": [
          "Per vrachtwagen: 12 × 24 = 288 pakketjes",
          "Totale capaciteit: 3 × 288 = 864",
          "Vergelijk: 864 pakketjes = 864 capaciteit → past precies ✓"
        ],
        "distractorExplanations": {
          "0": "Je berekende 3 × 12 × 20 = 720. Maar er passen 24 pakketjes per pallet, niet 20. 3 × 12 × 24 = 864.",
          "1": "Controleer je berekening: 12 × 24 = 288, dan 3 × 288 = 864 (niet 840).",
          "2": "Goed! Per vrachtwagen 12 × 24 = 288, en 3 × 288 = 864 pakketjes. Alles past precies.",
          "3": "Je berekende 3 × 12 × 25 = 900, dus 900 − 864 = 36 over. Maar er passen 24 pakketjes per pallet, niet 25. 3 × 12 × 24 = 864 — precies genoeg."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "rek.context-wrong-data", "label": "Verkeerd aantal per pallet (20 i.p.v. 24)", "optionIndex": 0 },
          { "id": "rek.calculation-error", "label": "Rekenfout bij vermenigvuldigen", "optionIndex": 1 },
          { "id": "rek.context-wrong-data", "label": "Verkeerd aantal per pallet (25 i.p.v. 24)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-CONTEXT-MEERSTAPS-006",
      "familyId": "REK-CONTEXT-MEERSTAPS",
      "module": "Basisrekenen",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_meerstaps",
      "questionType": "fill_in",
      "question": "Een fiets kost €280. In de uitverkoop krijg je 25% korting. Daarna betaal je met een kortingsbon van €15. Hoeveel betaal je uiteindelijk?",
      "context": null,
      "options": [],
      "correctAnswer": "195",
      "data": {
        "acceptedAnswers": ["195", "€195", "195 euro"]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "strategySteps",
          "showWhen": "wrong",
          "data": {
            "title": "Eerst %, dan vast bedrag",
            "steps": [
              { "label": "25% van €280 = €70" },
              { "label": "€280 − €70 = €210", "highlight": true },
              { "label": "€210 − €15 = €195" }
            ],
            "label": "Volgorde: percentage eerst, vast bedrag daarna"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Eerst procent, dan vast bedrag",
            "content": "Stap 1: 25% van €280 = €280 ÷ 4 = €70 korting. Stap 2: Nieuwe prijs = €280 − €70 = €210. Stap 3: Kortingsbon eraf = €210 − €15 = €195. Let op: pas eerst het percentage toe, daarna het vaste bedrag!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_meerstaps_korting",
      "variantIndex": 6,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.83,
      "feedback": {
        "explanationText": "Stap 1: 25% van €280 = €70 korting → €210. Stap 2: Kortingsbon: €210 − €15 = €195. Volgorde is belangrijk: eerst het percentage van de oorspronkelijke prijs, daarna het vaste bedrag eraf. Tegenproef: €210 − €15 = €195 ✓",
        "solutionSteps": [
          "25% van €280 = €280 ÷ 4 = €70",
          "Prijs na korting: €280 − €70 = €210",
          "Met kortingsbon: €210 − €15 = €195 ✓"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "rek.context-wrong-order", "label": "Verkeerde volgorde: bon eerst, dan percentage" },
          { "id": "rek.context-step-forgotten", "label": "Kortingsbon vergeten" },
          { "id": "rek.calculation-error", "label": "Stap overgeslagen of rekenfout" }
        ]
      }
    },
    {
      "id": "REK-CONTEXT-MEERSTAPS-007",
      "familyId": "REK-CONTEXT-MEERSTAPS",
      "module": "Basisrekenen",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_meerstaps",
      "questionType": "step_solver",
      "question": "Een trein rijdt van Amsterdam naar Maastricht, een afstand van 215 km. De trein rijdt gemiddeld 86 km per uur en stopt onderweg 3 keer 5 minuten op een station. Hoe lang duurt de hele reis in minuten?",
      "context": null,
      "options": [],
      "correctAnswer": "165",
      "data": {
        "stepSolver": {
          "context": "Afstand 215 km, snelheid 86 km/u, 3 stops van 5 minuten",
          "steps": [
            {
              "prompt": "Hoeveel uur duurt het rijden? (215 ÷ 86)",
              "correctAnswer": "2,5",
              "acceptedAnswers": ["2,5", "2.5", "2 1/2"],
              "hint": "215 ÷ 86 = ? Tip: 86 × 2 = 172, en 86 × 2,5 = 215."
            },
            {
              "prompt": "Hoeveel minuten is 2,5 uur?",
              "correctAnswer": "150",
              "acceptedAnswers": ["150", "150 min"],
              "hint": "1 uur = 60 minuten, dus 2,5 × 60 = ?"
            },
            {
              "prompt": "Hoeveel minuten zijn de stops samen? (3 × 5)",
              "correctAnswer": "15",
              "acceptedAnswers": ["15", "15 min"],
              "hint": "Drie keer 5 minuten stilstaan"
            },
            {
              "prompt": "Hoe lang duurt de hele reis in minuten? (rijden + stops)",
              "correctAnswer": "165",
              "acceptedAnswers": ["165", "165 min", "165 minuten"],
              "hint": "150 + 15"
            }
          ],
          "showStepsProgressively": true
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tijd = afstand ÷ snelheid, daarna stops erbij",
            "content": "Stap 1: Rijtijd = 215 ÷ 86 = 2,5 uur. Stap 2: Omrekenen: 2,5 × 60 = 150 minuten. Stap 3: Stops: 3 × 5 = 15 minuten. Stap 4: Totaal = 150 + 15 = 165 minuten. Vergeet niet om eenheden om te rekenen!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_meerstaps_tijd_snelheid",
      "variantIndex": 7,
      "citoDifficulty": 0.64,
      "citoDiscrimination": 0.81,
      "feedback": {
        "explanationText": "Stap 1: Rijtijd = 215 ÷ 86 = 2,5 uur. Stap 2: 2,5 uur = 2,5 × 60 = 150 minuten. Stap 3: Stops = 3 × 5 = 15 minuten. Stap 4: Totaal = 150 + 15 = 165 minuten. Bij tijd-opgaven: eerst rijtijd berekenen, omrekenen naar de gevraagde eenheid, dan stops/extra's optellen. Tegenproef: 150 + 15 = 165 minuten ✓",
        "solutionSteps": [
          "Rijtijd: 215 ÷ 86 = 2,5 uur",
          "Omrekenen: 2,5 × 60 = 150 minuten",
          "Stops: 3 × 5 = 15 minuten",
          "Totaal: 150 + 15 = 165 minuten ✓"
        ]
      },
      "pedagogy": {
        "dok": 3
      }
    },
    {
      "id": "REK-CONTEXT-MEERSTAPS-008",
      "familyId": "REK-CONTEXT-MEERSTAPS",
      "module": "Basisrekenen",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_meerstaps",
      "questionType": "multiple_choice",
      "question": "Een recept voor pannenkoeken voor 4 personen heeft 240 gram bloem, 3 eieren en 180 ml melk nodig. Je wilt pannenkoeken bakken voor 14 personen. Hoeveel eieren heb je minimaal nodig? (je kunt geen halve eieren gebruiken)",
      "context": null,
      "options": ["10 eieren", "11 eieren", "12 eieren", "9 eieren"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verhouding berekenen, dan naar boven afronden",
            "content": "Stap 1: Hoeveel keer zoveel? 14 ÷ 4 = 3,5. Stap 2: Eieren = 3 × 3,5 = 10,5. Stap 3: Naar boven afronden = 11 eieren (je kunt geen halve gebruiken, en met 10 heb je er te weinig).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_meerstaps_verhouding_recept",
      "variantIndex": 8,
      "citoDifficulty": 0.60,
      "citoDiscrimination": 0.82,
      "feedback": {
        "explanationText": "Stap 1: 14 ÷ 4 = 3,5 (factor). Stap 2: Eieren nodig = 3 × 3,5 = 10,5. Stap 3: Naar boven afronden → 11 eieren. Bij 'minimaal nodig' rond je altijd naar boven af. Tegenproef: 11 × 4 ÷ 3 = 14,67 ≥ 14 ✓",
        "solutionSteps": [
          "Schaal: 14 ÷ 4 = 3,5",
          "Eieren: 3 × 3,5 = 10,5",
          "Minimaal nodig: naar boven → 11 eieren ✓"
        ],
        "distractorExplanations": {
          "0": "Je rondde 10,5 naar beneden af. Maar met 10 eieren heb je te weinig (genoeg voor 13,33 personen). Je hebt 11 eieren nodig.",
          "1": "Goed! 14 ÷ 4 = 3,5 → 3 × 3,5 = 10,5 → naar boven = 11 eieren.",
          "2": "12 is te veel. 10,5 rond je af naar 11, niet 12. Met 11 eieren heb je genoeg voor 14 personen.",
          "3": "Je rekende 3 × 3 = 9, maar dat is voor 12 personen (3 × 4). Voor 14 personen: 3 × 3,5 = 10,5 → 11 eieren."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "rek.rounding-wrong-direction", "label": "Naar beneden afgerond i.p.v. naar boven", "optionIndex": 0 },
          { "id": "rek.rounding-overshoot", "label": "Te ver naar boven afgerond", "optionIndex": 2 },
          { "id": "rek.context-wrong-scale", "label": "Verkeerde schaalfactor (3 i.p.v. 3,5)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-CONTEXT-MEERSTAPS-009",
      "familyId": "REK-CONTEXT-MEERSTAPS",
      "module": "Basisrekenen",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_meerstaps",
      "questionType": "multiple_choice",
      "question": "Groep 8 heeft €450 budget voor het schoolreisje. De bus kost €185. Voor elke leerling is €8 entree nodig. Er gaan 28 leerlingen en 3 begeleiders mee (begeleiders gaan gratis naar binnen). Houden ze geld over, en zo ja hoeveel?",
      "context": null,
      "options": [
        "Nee, ze komen €17 tekort",
        "Ja, ze houden €41 over",
        "Ja, ze houden €17 over",
        "Ja, ze houden €49 over"
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Lees zorgvuldig: wie betaalt entree?",
            "content": "Stap 1: Entree alleen voor leerlingen (begeleiders gratis): 28 × €8 = €224. Stap 2: Bus: €185. Stap 3: Totale kosten: €224 + €185 = €409. Stap 4: Over: €450 − €409 = €41. Let op: tel niet de begeleiders mee voor entree!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_meerstaps_budget",
      "variantIndex": 9,
      "citoDifficulty": 0.66,
      "citoDiscrimination": 0.84,
      "feedback": {
        "explanationText": "Stap 1: Entree leerlingen = 28 × €8 = €224 (begeleiders gratis!). Stap 2: Bus = €185. Stap 3: Totale kosten = €224 + €185 = €409. Stap 4: Over = €450 − €409 = €41. Lees de opgave goed: alleen leerlingen betalen entree. Tegenproef: €224 + €185 = €409, €450 − €409 = €41 ✓",
        "solutionSteps": [
          "Entree leerlingen: 28 × €8 = €224",
          "Bus: €185",
          "Totaal kosten: €224 + €185 = €409",
          "Over: €450 − €409 = €41 ✓"
        ],
        "distractorExplanations": {
          "0": "Je rekende waarschijnlijk: 28 × €8 = €224 entree + €185 bus = €409, maar daarna een rekenfout (bv. €450 − €467) en kwam zo op 'tekort'. Lees de opgave: er is €450 budget en €409 nodig — ze houden geld OVER, niet tekort. Verschil: €41 over.",
          "1": "Goed! 28 × €8 = €224 entree + €185 bus = €409 kosten. €450 − €409 = €41 over.",
          "2": "Je telde de 3 begeleiders mee voor entree: 31 × €8 = €248. Daarbij de bus €185 → €433 kosten → €17 over. Maar begeleiders gaan gratis naar binnen! Alleen 28 × €8 = €224. Correct: €41 over.",
          "3": "Off-by-one bij het aantal leerlingen: 27 × €8 = €216 + €185 = €401 → €49 over. Maar er gaan 28 leerlingen mee, niet 27. 28 × €8 = €224, dus €41 over."
        }
      },
      "pedagogy": {
        "dok": 4,
        "misconceptionTags": [
          { "id": "rek.calculation-error", "label": "Rekenfout met sign/over-vs-tekort", "optionIndex": 0 },
          { "id": "rek.context-wrong-data", "label": "Begeleiders meegerekend voor entree", "optionIndex": 2 },
          { "id": "rek.calculation-error", "label": "Off-by-one in aantal leerlingen", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-CONTEXT-MEERSTAPS-010",
      "familyId": "REK-CONTEXT-MEERSTAPS",
      "module": "Basisrekenen",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_meerstaps",
      "questionType": "true_false_series",
      "question": "Klopt elke tussenstap in deze meerstaps-opgave? Beoordeel per stelling. Context: een feest voor 36 gasten met 4 hapjes per persoon, hapjes komen in schalen van 12.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          {
            "text": "Stap 1: Totaal hapjes = 36 × 4 = 144 hapjes.",
            "isTrue": true
          },
          {
            "text": "Stap 2: Aantal schalen = 144 ÷ 12 = 12 schalen.",
            "isTrue": true
          },
          {
            "text": "Tegenproef: 12 schalen × 12 hapjes = 132. Klopt met stap 1.",
            "isTrue": false
          },
          {
            "text": "Conclusie: er zijn precies 12 schalen nodig en er blijven geen hapjes over.",
            "isTrue": true
          }
        ]
      },
      "context": "Hapjes voor 36 gasten",
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tegenproef altijd narekenen",
            "content": "Bij meerstaps-opgaven: doe na elke stap een tegenproef. 12 × 12 = 144 (niet 132). Dus stap 1 en stap 2 kloppen, en de conclusie ook — maar de tegenproef in stelling 3 is rekenfout.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_meerstaps_judge_stappen",
      "variantIndex": 10,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.82,
      "feedback": {
        "explanationText": "Stap 1 (36 × 4 = 144) en stap 2 (144 ÷ 12 = 12) kloppen. Maar de tegenproef in stelling 3 is fout: 12 × 12 = 144, niet 132. Dat is een tafelfout — narekenen is altijd nodig. Conclusie klopt: 12 × 12 = 144 = totaal, dus geen rest.",
        "solutionSteps": [
          "Stelling 1: 36 × 4 = 144 ✓",
          "Stelling 2: 144 ÷ 12 = 12 ✓",
          "Stelling 3: 12 × 12 = 144 (niet 132) ✗ — tafelfout",
          "Stelling 4: 12 schalen × 12 hapjes = 144 = totaal, geen rest ✓"
        ]
      },
      "pedagogy": {
        "dok": 3
      }
    },
    {
      "id": "REK-CONTEXT-MEERSTAPS-011",
      "familyId": "REK-CONTEXT-MEERSTAPS",
      "module": "Basisrekenen",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_meerstaps",
      "questionType": "step_solver",
      "question": "Een zwembad heeft 1.250 liter water nodig. De kraan loopt 25 liter per minuut. Na 30 minuten doet de kraan het niet meer en wordt de rest met emmers van 8 liter erin gegooid. Hoeveel emmers zijn er minimaal nodig?",
      "options": [],
      "correctAnswer": "63",
      "data": {
        "steps": [
          {
            "prompt": "Hoeveel liter heeft de kraan in 30 minuten geleverd? (25 × 30)",
            "correctAnswer": "750",
            "acceptedAnswers": ["750", "750 liter", "750 l"],
            "hint": "25 liter per minuut × 30 minuten"
          },
          {
            "prompt": "Hoeveel liter moet er nog bij met emmers? (1.250 − 750)",
            "correctAnswer": "500",
            "acceptedAnswers": ["500", "500 liter", "500 l"],
            "hint": "Totaal nodig minus wat al in het bad zit"
          },
          {
            "prompt": "Hoeveel emmers van 8 liter? Reken: 500 ÷ 8 = ?",
            "correctAnswer": "62,5",
            "acceptedAnswers": ["62,5", "62.5", "62 1/2"],
            "hint": "500 ÷ 8 — let op: de uitkomst is geen heel getal"
          },
          {
            "prompt": "Hoeveel emmers minimaal nodig? (naar boven afronden)",
            "correctAnswer": "63",
            "acceptedAnswers": ["63", "63 emmers"],
            "hint": "62,5 emmers bestaat niet — je hebt er minimaal één meer nodig"
          }
        ],
        "showStepsProgressively": true
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Meerstaps: kraan + emmers",
            "content": "Stap 1: kraan levert 25 × 30 = 750 l. Stap 2: rest = 1.250 − 750 = 500 l. Stap 3: 500 ÷ 8 = 62,5. Stap 4: naar boven afronden → 63 emmers. Bij 'minimaal' altijd naar boven afronden!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_meerstaps_zwembad",
      "variantIndex": 11,
      "citoDifficulty": 0.62,
      "citoDiscrimination": 0.83,
      "feedback": {
        "explanationText": "Stap 1: kraan = 25 × 30 = 750 l. Stap 2: nog te vullen = 1.250 − 750 = 500 l. Stap 3: 500 ÷ 8 = 62,5 emmers. Stap 4: naar boven afronden → 63 emmers. Tegenproef: 63 × 8 = 504 ≥ 500 ✓.",
        "solutionSteps": [
          "Stap 1: 25 × 30 = 750 liter via kraan",
          "Stap 2: 1.250 − 750 = 500 liter via emmers",
          "Stap 3: 500 ÷ 8 = 62,5",
          "Stap 4: minimaal nodig → 63 emmers ✓"
        ]
      },
      "pedagogy": {
        "dok": 3
      }
    }
  ]
}